var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgentLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.436,
    height: 74.799,
    viewBox: "0 0 54.436 74.799",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1765",
    "data-name": "Group 1765",
    transform: "translate(-522.8 -48.204)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1893",
    "data-name": "Path 1893",
    d: "M223.413,60.181c-11.35,0-20.788,9.617-20.947,21.253q-.133,12.071-.186,24.143,6.038-.019,12.076-.028.023-12.092.08-24.185a8.978,8.978,0,1,1,17.954,0c-.055-11.663-.139-21.173-8.977-21.185Z",
    transform: "translate(326.605 -11.977)",
    fill: "#ffa200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1894",
    "data-name": "Path 1894",
    d: "M256,60.181c4.864,0,8.909,9.519,8.977,21.185q.057,12.092.08,24.185,6.038.008,12.076.028-.054-12.071-.186-24.143c-.159-11.638-9.6-21.25-20.947-21.254Z",
    transform: "translate(294.018 -11.977)",
    fill: "#ffbc20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1896",
    "data-name": "Path 1896",
    d: "M192.97,144.819a6.134,6.134,0,0,0-6.071,6.066q-.115,14.667-.078,29.335a6.081,6.081,0,0,0,6.063,6.046q6.041.015,12.083.022-.032-20.758.037-41.517Q198.987,144.785,192.97,144.819Z",
    transform: "translate(335.987 -63.29)",
    fill: "#ffbc20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1900",
    "data-name": "Path 1900",
    d: "M232.832,144.744q-4.587,0-9.175.011a6.088,6.088,0,0,0-6.047,6.061q-.064,14.7-.043,29.4a6.067,6.067,0,0,0,6.054,6.051q15.1.017,30.208-.022a6.082,6.082,0,0,0,6.063-6.046q.007-2.695.008-5.389C250.884,164.827,241.809,154.77,232.832,144.744Z",
    transform: "translate(317.334 -63.273)",
    fill: "#ffcc40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1901",
    "data-name": "Path 1901",
    d: "M283.447,174.814q.007-11.972-.086-23.945a6.134,6.134,0,0,0-6.071-6.066q-10.456-.058-20.912-.059A30.2,30.2,0,0,0,283.447,174.814Z",
    transform: "translate(293.788 -63.273)",
    fill: "#ffd85a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentLogin);
export default __webpack_public_path__ + "static/media/agent_login.535ae4151dcfd2d5f004719ba49cc6da.svg";
export { ForwardRef as ReactComponent };